import { useCallback } from "react";
import {
  forbiddenError,
  maintenanceError,
  notFoundError,
  steakError,
  unauthorizedError,
} from "../actions/common/errors";
import EmergencyInterface from "../interfaces/EmergencyInterface";
import { useAppDispatch } from "./useAppDispatch";

export const useErrorDispatcher = () => {
  const dispatch = useAppDispatch();

  const sendUnauthorized = useCallback(() => {
    dispatch(unauthorizedError());
  }, []);

  const sendNotFound = useCallback(() => {
    dispatch(notFoundError());
  }, []);

  const sendForbidden = useCallback(() => {
    dispatch(forbiddenError());
  }, []);

  const sendSteakEmergencyError = useCallback((error: EmergencyInterface) => {
    dispatch(steakError(error));
  }, []);

  const sendMaintenanceError = useCallback((error: string) => {
    dispatch(maintenanceError(error));
  }, []);

  return {
    sendUnauthorized,
    sendNotFound,
    sendForbidden,
    sendSteakEmergencyError,
    sendMaintenanceError,
  };
};
